import {
  Form,
  Input,
  Modal,
  Select,
  Space,
  Button,
  Tooltip,
  message,
  Dropdown
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef
} from "react";
import {
  MailOutlined,
  CheckOutlined,
  CloseOutlined,
  MenuOutlined,
  FormOutlined,
  HomeOutlined
} from "@ant-design/icons";
import parse from 'html-react-parser';
import http from "@/utils/http";
import moment from "moment";
import api from "@/utils/api";
import dayjs from "dayjs";
import PDFModal from "@/views/AccountPayable/ApprovalSummary/component/PDFModal"
import { useLocation } from 'react-router-dom';
import AddModal from "@/views/AccountPayable/UtilityPayment/component/AddModal" ;
import { CustomTable, CustomTableExtend, CustomUpload } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();

  const initTableHead = {
    vendorName: null,
    requestNumber: null,
    payAmount: null,
    requestStatus: null,
    perJobCost: null,
    requestStatusDate: null,
    requestEndDate: null,
    jobType: null,
    supervisor: null,
    needMaterial: null,
    materialAmount: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    {
      title: '#',
      dataIndex: '#',
    },
    {
      title: 'Name',
      dataIndex: "firstName",
      titleType: '',
      isSorter: false,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'firstName')
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const handleRouterClick = (ids) => {
    const url = `${window.location.origin}#/AccountPayable/BusinessLicense?ids=${ids}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const searchParams = getPropsParamsFn()
    const params = {
      // batch: searchParams.path,
    };
    const response = await http.get(api.commonSubmitCount, { params });

    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const tempColumnsList = (response?.data?.weekHeaders || [])?.map(item => (
      {
        title: item.value,
        dataIndex: item.label,
        titleType: '',
        isSorter: false,
        render: (text, record) => {
          if (!text){
            return text
          }
          return (
            <span 
              style={{
                color:'#1a52e0',
                cursor: 'pointer', 
              }}
              onClick={() => handleRouterClick(record?.[`${item.label}IdList`] || [])}  
            >
              {text}
            </span>
          );
        },        
      }
    ))
    setColumns([...initColumns, ...tempColumnsList]);
    const list = (response.data?.accountList || [])?.map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);

    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }))
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])
  
  const getPropsParamsFn = () => {
    const searchParams = new URLSearchParams(location.search);
 
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
      >
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={false}
        handleTableChange={handleTableChange}
      />
    </div>
  );
});
export default MainTable;